import { makeAutoObservable } from "mobx"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { notNull } from "@gap/utils/utils"
import { DocEmailAttachmentsTabsProps } from "./DocEmailAttachmentsTabs"

export default class DocEmailAttachmentsTabsStore {
   sp

   constructor(sp: DocEmailAttachmentsTabsProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   isActive = (value: string) => {
      return value === this.sp.value
   }

   clickHandler = (event: React.MouseEvent<HTMLElement>) => {
      const id = notNull(event.currentTarget.getAttribute("data-id"))
      this.sp.onChange(id)
   }
}

export const { Provider: DocEmailAttachmentsTabsStoreProvider, useProvidedStore: useDocEmailAttachmentsTabsStore } = createStoreContext(DocEmailAttachmentsTabsStore)
